import { DownArrowIcon } from '@/components/ui/DownArrowIcon';

export function Hero() {
  return (
    <section className="relative bg-white min-h-[80vh] flex items-center justify-center">
      {/* Background could be added here if needed */}
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Company Name */}
        <div className="mb-8">
          <h4 className="text-lg font-bold text-gray-700 mb-4">
            <span className="text-primary-navy">Centric MX</span>
          </h4>
        </div>

        {/* Main Headline */}
        <div className="mb-8">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-primary-navy leading-tight">
            ELEVATING SAFETY,<br />
            PRECISION, AND<br />
            PERFORMANCE
          </h1>
        </div>

        {/* Divider */}
        <div className="mb-8 flex justify-center">
          <div className="w-32 h-1 bg-primary-navy opacity-80"></div>
        </div>

        {/* Supporting Content */}
        <div className="max-w-4xl mx-auto">
          <div className="mb-8">
            <div className="flex items-center justify-center mb-4">
              <DownArrowIcon className="w-7 h-16 text-primary-navy" />
            </div>
            <p className="text-lg md:text-xl font-medium text-primary-navy">
              <span className="font-bold">Safety is our top priority</span>
              —your peace of mind is our mission.
            </p>
          </div>
          
          <div className="space-y-6 text-gray-700 text-base md:text-lg max-w-3xl mx-auto">
            <p>
              At Centric MX Aviation Maintenance, we are committed to keeping your aircraft in top condition. 
              Specializing in general aviation maintenance, we provide comprehensive services for a wide range of aircraft.
            </p>
            <p>
              From routine inspections and preventative maintenance to major repairs and avionics upgrades, 
              we offer a full suite of services tailored to meet the unique needs of each aircraft and owner. 
              With a focus on precision, safety, and reliability.
            </p>
            <p>
              Whether you're a private owner, a flight school, or a corporate fleet manager, 
              Centric MX Aviation Maintenance is your trusted partner for reliable, efficient, and expert care of your aircraft.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}